import _ from 'lodash';
import moment from 'moment';
import { Children, Fragment } from 'react';

const currencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });
export const formatUnixDate = (date, format = 'MMM-DD-YYYY') => moment.unix(date).format(format);
export const formatDate = (date, format = 'MMMM-DD-YYYY') => moment(date).format(format);
export const formatCurrency = currencyFormatter.format;
export const normalizeStr = _.flow(_.trim, _.toLower, _.deburr);
export const isNumber = (data) => typeof data === 'number';
export const flattenReactChildren = (children) => _.flatten(Children.map(children, (child) => (_.get(child, 'type') === Fragment ? flattenReactChildren(child.props.children) : child)));
export const delay = (ms) => new Promise((res) => setTimeout(res, ms));
export const getValue = (value, mapping = {}, defaultValue) => _.get(mapping, [value], defaultValue);
export const objectToArrayObject = (data) => Object.entries(data).map(([key, value]) => ({ [key]: value }));
export const compareTime = (timeA, timeB) => Math.abs(Number(timeA) - Number(timeB));
export const toDataArray = (entries, columns, formattedColumns) => {
  const formatRow = (rowData) => _.map(columns, ({ value, valueRaw }) => {
    const getFinalValue = () => (_.hasIn(rowData, valueRaw)
      ? _.get(rowData, valueRaw)
      : value({ rowData }));

    if (_.get(formattedColumns, valueRaw, false) === false) {
      return getFinalValue();
    }
    const formatter = formattedColumns[valueRaw];
    return _.isFunction(formatter)
      ? formatter(getFinalValue())
      : value({ rowData });
  });

  return [
    _.map(columns, 'label'),
    ...(_.map(entries, formatRow)),
  ];
};

export const pickBy = (object) => {
  const obj = {};
  for (const key in object) {
    if (object[key]) {
      obj[key] = object[key];
    }
  }
  return obj;
};

export const getParam = (param) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(param);
};

export const hasAnEmptySpace = (text) => /\s/.test(text);
export const removeEmptySpaces = (text) => text.replace(/\s/g, '');
